import type { ColorRamp } from './types';

// Named color ramps shared across year themes. Defining them once keeps palettes
// DRY — a year's theme composes from these rather than restating hex values.

/** Brand purple — the default primary (2025). Mirrors the @theme block in index.css. */
export const purple: ColorRamp = {
  '50': '#f5f3fb',
  '100': '#ede8f8',
  '200': '#dcd4f1',
  '300': '#c2b3e6',
  '400': '#a489d8',
  '500': '#8a62ca',
  '600': '#7e57c5',
  '700': '#6a41a8',
  '800': '#573789',
  '900': '#492f6f',
  '950': '#2e1e4a',
};

/** Brand orange — the default accent (2025). */
export const orange: ColorRamp = {
  '50': '#fef6ec',
  '100': '#fdebd3',
  '200': '#fad3a5',
  '300': '#f7b56d',
  '400': '#f49333',
  '500': '#f18a00',
  '600': '#d97706',
  '700': '#b45309',
  '800': '#92400e',
  '900': '#78350f',
  '950': '#451a03',
};

/** Brand blue — secondary, shared across years. */
export const blue: ColorRamp = {
  '50': '#f0f9ff',
  '100': '#e0f2fe',
  '200': '#bae6fd',
  '300': '#7dd3fc',
  '400': '#38bdf8',
  '500': '#0ea5e9',
  '600': '#0097ce',
  '700': '#0369a1',
  '800': '#075985',
  '900': '#0c4a6e',
  '950': '#082f49',
};

/** Brand green — success, shared across years. */
export const green: ColorRamp = {
  '50': '#f0fdf4',
  '100': '#dcfce7',
  '200': '#bbf7d0',
  '300': '#86efac',
  '400': '#4ade80',
  '500': '#22c55e',
  '600': '#00b451',
  '700': '#15803d',
  '800': '#166534',
  '900': '#14532d',
  '950': '#052e16',
};

/** Ocean teal — 2026 primary, evoking the Andaz Miami Beach setting. */
export const teal: ColorRamp = {
  '50': '#e6fbf7',
  '100': '#c7f5ec',
  '200': '#90ebd9',
  '300': '#57dcc4',
  '400': '#29c4ab',
  '500': '#00a79d',
  '600': '#00897f',
  '700': '#006e67',
  '800': '#075852',
  '900': '#0a4944',
  '950': '#002b28',
};

/** Coral — 2026 accent. */
export const coral: ColorRamp = {
  '50': '#fdf2f6',
  '100': '#fce7ef',
  '200': '#fbcfdf',
  '300': '#f7a8c4',
  '400': '#f175a2',
  '500': '#e6558f',
  '600': '#d23475',
  '700': '#b02160',
  '800': '#931c52',
  '900': '#7c1b48',
  '950': '#470a25',
};
